import countries from "./country_mapping.json";
export const countryMapping = (code: string): string => countries[code] || code;
